import { ComumService } from '../../comum/comum.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Telefone } from './../../comum/modelos/telefone';
import { Endereco } from './../../comum/modelos/endereco';
import { EnderecoCliente } from '../../comum/modelos/endereco-cliente';
import { TelefoneCliente } from '../../comum/modelos/telefone-cliente';
import { Paginacao } from '../../comum/modelos/paginacao';
import { ClienteService } from './../cliente.service';
import { Cliente } from '../../comum/modelos/cliente';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { AreaCliente } from '../../comum/modelos/area-cliente';
import { Area } from '../../comum/modelos/area';

@Component({
    selector: 'app-cadastro-cliente',
    templateUrl: './cadastro-cliente.component.html',
    styleUrls: ['./cadastro-cliente.component.css']
})
export class CadastroClienteComponent implements OnInit {

    private CADASTRAR = 'Cadastrar';
    private ATUALIZAR = 'Atualizar';
    private MODO: string;

    public cliente: Cliente;
    public logo: File;
    public cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public telefonesClienteRemovidos: TelefoneCliente[];
    public enderecosClienteRemovidos: EnderecoCliente[];
    public areasClienteRemovidas: AreaCliente[];
    public telefonesClienteInseridos: TelefoneCliente[];
    public enderecosClienteInseridos: EnderecoCliente[];
    public areasClienteInseridas: AreaCliente[];
    public telefonesClienteAtualizados: TelefoneCliente[];
    public enderecosClienteAtualizados: EnderecoCliente[];
    public areasClienteAtualizadas: AreaCliente[];

    public paginacaoTelefone: Paginacao;
    public paginacaoEndereco: Paginacao;
    public paginacaoArea: Paginacao;
    public loading = false;
    public statusCode: number;

    constructor (private _clienteService: ClienteService,
        private _comumService: ComumService,
        private _activatedRoute: ActivatedRoute,
        private _authService: AuthService,
        private router: Router) {

        this.cliente = new Cliente();

        this.paginacaoTelefone = new Paginacao();
        this.paginacaoEndereco = new Paginacao();
        this.paginacaoArea = new Paginacao();

        this.paginacaoTelefone.itens = 3;
        this.paginacaoTelefone.page = 1;
        this.paginacaoTelefone.id = 'telefone';

        this.paginacaoEndereco.itens = 3;
        this.paginacaoEndereco.page = 1;
        this.paginacaoEndereco.id = 'endereco';

        this.paginacaoArea.itens = 3;
        this.paginacaoArea.page = 1;
        this.paginacaoArea.id = 'area';

        this.telefonesClienteRemovidos = new Array<TelefoneCliente>();
        this.enderecosClienteRemovidos = new Array<EnderecoCliente>();
        this.areasClienteRemovidas = new Array<AreaCliente>();
        this.telefonesClienteInseridos = new Array<TelefoneCliente>();
        this.enderecosClienteInseridos = new Array<EnderecoCliente>();
        this.areasClienteInseridas = new Array<AreaCliente>();
        this.telefonesClienteAtualizados = new Array<TelefoneCliente>();
        this.enderecosClienteAtualizados = new Array<EnderecoCliente>();
        this.areasClienteAtualizadas = new Array<AreaCliente>();
    }

    ngOnInit() {
        this.obterClientePorId(this._activatedRoute.snapshot.params['id']);
    }

    onSubmit(): void {

        const self = this;

        if (this.MODO === this.CADASTRAR) {
            this._clienteService.cadastrarClienteHttp(this.cliente, this.logo)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                    this.router.navigate(['listar-clientes/']);
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        } else {
            self.processarTelefonesCliente();
            self.processarEnderecosCliente();
            self.processarAreasCliente();
            this._clienteService.atualizarClienteHttp(this.cliente, this.logo)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                    if (this._authService.isAdmin) {
                        self.router.navigate(['listar-clientes/']);
                    } else {
                        self.router.navigate(['/']);
                    }
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
    }

    processarTelefonesCliente(): void {
        this.cliente.telefonesCliente.forEach(telefoneCliente => {
            if (telefoneCliente.alterado) {
                if (telefoneCliente.idTelefoneCliente === undefined) {
                    telefoneCliente.idCliente = this.cliente.idCliente;
                    this.telefonesClienteInseridos.push(telefoneCliente);
                } else {
                    this.telefonesClienteAtualizados.push(telefoneCliente);
                }
            }
        });
        console.log(this.telefonesClienteRemovidos.length);
        if (this.telefonesClienteRemovidos.length > 0) {
            this._clienteService.removerTelefonesClienteHttp(this.telefonesClienteRemovidos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.telefonesClienteInseridos.length > 0) {
            this._clienteService.cadastrarTelefonesClienteHttp(this.telefonesClienteInseridos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.telefonesClienteAtualizados.length > 0) {
            this._clienteService.atualizarTelefonesClienteHttp(this.telefonesClienteAtualizados)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
    }

    processarEnderecosCliente(): void {
        this.cliente.enderecosCliente.forEach(enderecoCliente => {
            if (enderecoCliente.alterado) {
                if (enderecoCliente.idEnderecoCliente === undefined) {
                    enderecoCliente.idCliente = this.cliente.idCliente;
                    this.enderecosClienteInseridos.push(enderecoCliente);
                } else {
                    this.enderecosClienteAtualizados.push(enderecoCliente);
                }
            }
        });

        if (this.enderecosClienteRemovidos.length > 0) {
            this._clienteService.removerEnderecosClienteHttp(this.enderecosClienteRemovidos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.enderecosClienteInseridos.length > 0) {
            this._clienteService.cadastrarEnderecosClienteHttp(this.enderecosClienteInseridos)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.enderecosClienteAtualizados.length > 0) {
            this._clienteService.atualizarEnderecosClienteHttp(this.enderecosClienteAtualizados)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
    }

    processarAreasCliente(): void {
        this.cliente.areasCliente.forEach(areaCliente => {
            if (areaCliente.alterado) {
                if (areaCliente.idAreaCliente === undefined) {
                    areaCliente.idCliente = this.cliente.idCliente;
                    this.areasClienteInseridas.push(areaCliente);
                } else {
                    this.areasClienteAtualizadas.push(areaCliente);
                }
            }
        });
        console.log(this.areasClienteRemovidas.length);
        if (this.areasClienteRemovidas.length > 0) {
            this._clienteService.removerAreasClienteHttp(this.areasClienteRemovidas)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.areasClienteInseridas.length > 0) {
            this._clienteService.cadastrarAreasClienteHttp(this.areasClienteInseridas)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }

        if (this.areasClienteAtualizadas.length > 0) {
            this._clienteService.atualizarAreasClienteHttp(this.areasClienteAtualizadas)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
    }

    receberTelefone(telefone: Telefone): void {
        const telefoneCliente = new TelefoneCliente(telefone);
        telefoneCliente.alterado = true;
        this.cliente.telefonesCliente.push(telefoneCliente);
    }

    receberEndereco(endereco: Endereco): void {
        const enderecoCliente = new EnderecoCliente(endereco);
        enderecoCliente.alterado = true;
        this.cliente.enderecosCliente.push(enderecoCliente);
    }

    receberArea(area: Area): void {
        const areaCliente = new AreaCliente(area);
        areaCliente.alterado = true;
        this.cliente.areasCliente.push(areaCliente);
    }

    atualizarTelefone(telefone: Telefone): void {
        for (let i = 0; i < this.cliente.telefonesCliente.length; i++) {
            const telefoneCliente = this.cliente.telefonesCliente[i];
            if (telefone.idTelefone === undefined) {
                if (i === telefone.index) {
                    telefoneCliente.alterado = true;
                    telefoneCliente.telefone = telefone;
                    break;
                }
            } else {
                if (telefoneCliente.telefone.idTelefone === telefone.idTelefone) {
                    telefoneCliente.alterado = true;
                    telefoneCliente.telefone = telefone;
                    break;
                }
            }
        }
    }

    atualizarEndereco(endereco: Endereco): void {
        for (let i = 0; i < this.cliente.enderecosCliente.length; i++) {
            const enderecoCliente = this.cliente.enderecosCliente[i];
            if (endereco.idEndereco === undefined) {
                if (i === endereco.index) {
                    enderecoCliente.alterado = true;
                    enderecoCliente.endereco = endereco;
                    break;
                }
            } else {
                if (enderecoCliente.endereco.idEndereco === endereco.idEndereco) {
                    enderecoCliente.alterado = true;
                    enderecoCliente.endereco = endereco;
                    break;
                }
            }
        }
    }

    atualizarArea(area: Area): void {
        for (let i = 0; i < this.cliente.areasCliente.length; i++) {
            const areaCliente = this.cliente.areasCliente[i];
            if (area.idArea === undefined) {
                if (i === area.index) {
                    areaCliente.alterado = true;
                    areaCliente.area = area;
                    break;
                }
            } else {
                if (areaCliente.area.idArea === area.idArea) {
                    areaCliente.alterado = true;
                    areaCliente.area = area;
                    break;
                }
            }
        }
    }

    removerTelefoneCliente(telefoneCliente: TelefoneCliente): void {
        if (this.MODO === this.ATUALIZAR) {
            if (telefoneCliente.idTelefoneCliente !== undefined) {
                this.telefonesClienteRemovidos.push(telefoneCliente);
            }
        }
        const index = this.cliente.telefonesCliente.indexOf(telefoneCliente);
        this.cliente.telefonesCliente.splice(index, 1);
    }

    removerEnderecoCliente(enderecoCliente: EnderecoCliente): void {
        if (this.MODO === this.ATUALIZAR) {
            if (enderecoCliente.idEnderecoCliente !== undefined) {
                this.enderecosClienteRemovidos.push(enderecoCliente);
            }
        }
        const index = this.cliente.enderecosCliente.indexOf(enderecoCliente);
        this.cliente.enderecosCliente.splice(index, 1);
    }

    removerAreaCliente(areaCliente: AreaCliente): void {
        if (this.MODO === this.ATUALIZAR) {
            if (areaCliente.idAreaCliente !== undefined) {
                this.areasClienteRemovidas.push(areaCliente);
            }
        }
        const index = this.cliente.areasCliente.indexOf(areaCliente);
        this.cliente.areasCliente.splice(index, 1);
    }

    obterClientePorId(id: number): void {
        this.loading = true;
        if (id !== undefined) {
            this._clienteService.obterClientePorIdHttp(id)
                .subscribe((cliente: Cliente) => {
                    this.cliente = cliente;
                    this.MODO = this.ATUALIZAR;
                    this.loading = false;
                });
        } else {
            this.MODO = this.CADASTRAR;
            this.loading = false;
        }
    }

    onFileChanged(event) {
        this.logo = event.target.files[0];
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/cliente/cadastro-cliente/cadastro-cliente.component.ts